import { render, staticRenderFns } from "./CameraItem.vue?vue&type=template&id=3b58d080&scoped=true&"
import script from "./CameraItem.vue?vue&type=script&lang=ts&"
export * from "./CameraItem.vue?vue&type=script&lang=ts&"
import style0 from "./CameraItem.vue?vue&type=style&index=0&id=3b58d080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58d080",
  null
  
)

export default component.exports